"use strict";

module.exports = /* @ngInject */ function() {
  var session = {};
  var that = this;

  that.set = function(sessionInfo) {
    session = sessionInfo;
  };

  that.reset = function() {
    session = {};
  };

  that.getToken = function() {
    return session.sessionToken;
  };

  that.getInstanceId = function() {
    return session.instanceId;
  };

  that.hasValidSession = function() {
    return !!that.getToken() && !!that.getInstanceId();
  };
};



// WEBPACK FOOTER //
// ./app/infrastructure/repositories/sideBySideSessionRepository.js